import { HttpClient, STATIC_ROOT } from "@/api/httpClient"

export default {
	unfairClauses() {
		return HttpClient.get<{ text: string }>(`${STATIC_ROOT}/registration/unfair-clauses`)
	}
}
